// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../config/api";
import config from "../../config/config";
import { getCurrentLoggedInSessionToken } from "../../config/userPool";

const {
  SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LISTING_ENDPOINT,
  SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_DETAIL_ENDPOINT,
  AUDIT_ENDPOINT,

} = config.api_endpoint;

const initialState = {
  loading: false,
  configure_suspension_list: [],
  error: null,
  detail_loading: false,
  detail_data: {},
  detail_error: null,
  audit_data: [],
  audit_loading: false,
  audit_error: null,
};


export const fetchConfigureSuspensionList = createAsyncThunk(
  "configureSuspension/fetchConfigureSuspensionList",
  async (_, { rejectWithValue }) => {
    console.log('erewreaw');

    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LISTING_ENDPOINT}`;


      const results = await api.get(url, {}, token);

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchConfigureSuspensionDetail = createAsyncThunk(
  "configureSuspension/fetchConfigureSuspensionDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_DETAIL_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const updateConfigureSuspensionStatus = createAsyncThunk(
  "configureSuspension/updateConfigureSuspensionStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LISTING_ENDPOINT}/${id}/status`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;



    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const createAndUpdateConfigureSuspension = createAsyncThunk(
  "configureSuspension/createAndUpdateConfigureSuspension",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LISTING_ENDPOINT}/${id}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;



    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const fetchConfigureSuspensionAudit = createAsyncThunk(
  "configureSuspension/fetchConfigureSuspensionAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${AUDIT_ENDPOINT}?table_name=booking-config&source_id=${id}`;
      const results = await api.get(url, {}, token);
      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

const configureSuspensionSlice = createSlice({
  name: "configure-suspension",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfigureSuspensionDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchConfigureSuspensionDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.detail_data = action.payload;
      })
      .addCase(fetchConfigureSuspensionDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.detail_error = action.error.message;
      })
      .addCase(fetchConfigureSuspensionAudit.pending, (state) => {
        state.audit_loading = true;
      })
      .addCase(fetchConfigureSuspensionAudit.fulfilled, (state, action) => {
        state.audit_loading = false;
        state.audit_data = action.payload;
      })
      .addCase(fetchConfigureSuspensionAudit.rejected, (state, action) => {
        state.audit_loading = false;
        state.audit_error = action.error.message;
      })
      .addCase(fetchConfigureSuspensionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchConfigureSuspensionList.fulfilled, (state, action) => {
        state.loading = false;
        state.configure_suspension_list = action.payload;
      })
      .addCase(fetchConfigureSuspensionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateConfigureSuspensionStatus.pending, (state) => {
        state.loading = true;
        state.detail_loading = true;
      })
      .addCase(updateConfigureSuspensionStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.detail_loading = false;
      })
      .addCase(updateConfigureSuspensionStatus.rejected, (state, action) => {
        state.loading = false;
        state.detail_loading = false;
      })
  },
});

const ShuttleBusConfigureSuspensionReducer = configureSuspensionSlice.reducer;
export default ShuttleBusConfigureSuspensionReducer;
